import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Account, AccountListFilter } from '../account.model';
import { AccountActions, AccountActionTypes, AccountListFilterActions, AccountListFilterActionTypes } from '../actions/account.actions';

export interface State extends EntityState<Account> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<Account> = createEntityAdapter<Account>({
  selectId: account => account.Acode
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(
  state = initialState,
  action: AccountActions
): State {
  switch (action.type) {
    case AccountActionTypes.GetAccounts: {
      return {...state, Loaded: false, Loading: true};
    }

    case AccountActionTypes.GetAllAccounts: {
      return {...state, Loaded: false, Loading: true};
    }

    // case AccountActionTypes.GetAccountList: {
    //   return {...state, Loaded: false, Loading: true};
    // }

    case AccountActionTypes.GetAccountsFail: {
      return {...state, Loaded: true, Loading: false};
    }

    case AccountActionTypes.AddAccount: {
      return adapter.addOne(action.payload.account, state);
    }

    case AccountActionTypes.UpsertAccount: {
      return adapter.upsertOne(action.payload.account, state);
    }

    case AccountActionTypes.AddAccounts: {
      return adapter.addMany(action.payload.accounts, state);
    }

    case AccountActionTypes.UpsertAccounts: {
      return adapter.upsertMany(action.payload.accounts, {...state, Loaded: true, Loading: false});
    }

    case AccountActionTypes.UpdateAccount: {
      return adapter.updateOne(action.payload.account, state);
    }

    case AccountActionTypes.UpdateAccounts: {
      return adapter.updateMany(action.payload.accounts, state);
    }

    case AccountActionTypes.DeleteAccount: {
      return adapter.removeOne(action.payload.id, state);
    }

    case AccountActionTypes.DeleteAccounts: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case AccountActionTypes.LoadAccounts: {
      return adapter.setAll(action.payload.accounts, {...state, Loaded: true, Loading: false});
    }

    case AccountActionTypes.ClearAccounts: {
      return adapter.removeAll(state);
    }

    case AccountActionTypes.NoAccountsChanged: {
      return {...state, Loaded: true, Loading: false};
    }

    case AccountActionTypes.GetClientAccount: {
      return {...state, Loaded: false, Loading: true};
    }

    default: {
      return state;
    }
  }
}

export interface AccountFilterState {
  Loaded: boolean;
  Filter: AccountListFilter;
}

export const initialAccountState: AccountFilterState = {
  Loaded: false,
  Filter: {Acodes: [], Authority: -1, AuthorityRegion: []} as AccountListFilter
};

export function AccountFilterreducer(state = initialAccountState, action: AccountListFilterActions): AccountFilterState {
  switch (action.type) {

    case AccountListFilterActionTypes.SelectAccountListFilters:
      return {...state, Loaded: true, Filter: action.payload};

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
